module.exports = __webpack_public_path__ + "static/not-found.93b7c3e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/not-found.png
// module id = 829
// module chunks = 162898551421021